<template>
  <el-dialog
    :title="`添加游客：${project_name} ${guide.service_duration}分钟 ${temp.use_date} ${
      temp.interval_time
    } ${temp.trip_type === 1 ? '拼团' : '包团'}`"
    :visible.sync="dialogFormVisible"
    width="700px"
  >
    <div class="filter-container">
      <el-input
        style="width: 160px"
        class="filter-item"
        v-model="temp.contact_name"
        placeholder="请输入姓名"
      />
      <el-input
        style="width: 160px"
        class="filter-item"
        v-model="temp.contact_mobile"
        placeholder="请输入手机号"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >查询</el-button
      >
    </div>
    <Table :data="list" :columns="columns" :loading="listLoading" @changeSelect="changeSelect">
      <template v-slot:selection>
        <el-table-column width="50" align="center" type="selection"> </el-table-column>
      </template>
      <template v-slot:name>
        <el-table-column label="姓名" width="140">
          <template slot-scope="scope">
            {{ scope.row.contact.name }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:mobile>
        <el-table-column label="手机号" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.contact.mobile }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:source>
        <el-table-column label="平台" width="160" align="center">
          <template slot-scope="scope">
            {{ $platform[scope.row.source] }}
          </template>
        </el-table-column>
      </template>
    </Table>
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="temp.page"
        :limit.sync="temp.size"
        @pagination="fetchData"
      />
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取消</el-button>
      <el-button v-if="sendBtnShow" type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getWaitOrderList, addTourist } from '@/api/batchOrder'
export default {
  name: 'AddOrderList',
  data() {
    return {
      dialogFormVisible: false,
      list: [],
      listLoading: true,
      count: 0,
      order_ids: [],
      sendBtnShow: false,
      temp: {
        page: 1,
        size: 10,
        contact_name: '',
        contact_mobile: '',
        project_id: '',
        use_date: '',
        interval_time: '',
        trip_type: ''
      },
      project_name: '',
      guide: {},
      columns: [
        { type: 'selection', slot: 'selection' },
        {
          slot: 'name',
          label: '姓名'
        },
        {
          slot: 'mobile',
          label: '手机号'
        },
        {
          slot: 'source',
          label: '平台'
        },
        {
          prop: 'user_num',
          label: '人数'
        }
      ]
    }
  },
  created() {},
  methods: {
    fetchData() {
      getWaitOrderList(this.temp).then((res) => {
        this.list = res.data.results
        this.listLoading = false
        this.count = res.data.count
      })
    },
    handleAddOrder(guide, listQuery, project_name) {
      console.log(guide, listQuery, project_name)
      this.temp = {
        ...listQuery,
        page: 1,
        size: 10
      }
      this.project_name = project_name
      this.guide = guide
      this.dialogFormVisible = true
      this.fetchData()
    },
    handleFilter() {
      this.fetchData()
    },
    /**
     * @description: 选择行
     * @return {*}
     */
    changeSelect(e) {
      this.sendBtnShow = !!e.length > 0
      this.order_ids = e.map((item) => item.order_id)
    },
    onCancel() {
      this.dialogFormVisible = false
      this.order_ids = []
      this.sendBtnShow = false
    },
    /**
     * @description: 添加游客
     * @return {*}
     */
    saveData() {
      if (this.order_ids.length === 0) {
        this.$message.warning('请选择游客')
        return
      }
      const { project_id, use_date, interval_time, trip_type } = this.temp
      addTourist({
        order_ids: this.order_ids,
        project_id,
        use_date,
        interval_time,
        guide_id: this.guide.guide_id,
        trip_type
      }).then(() => {
        this.$message.success('添加成功')
        this.dialogFormVisible = false
        this.order_ids = []
        this.sendBtnShow = false
        this.$emit('saveOrderData')
      })
    }
  }
}
</script>
<style scoped>
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}
</style>
